"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPCUpdate = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var commonweb_utils_1 = require("commonweb-utils");
var icons_component_1 = require("../../components/icons.component");
var constants_1 = require("../../constants");
/**
 * PP credit update suggestion page
 */
function PPCUpdate(_a) {
    var content = _a.content, account = _a.account, route = _a.route, fpti = _a.fpti, transitionOutHandler = _a.transitionOutHandler;
    var commonContent = content.common;
    var phoneFpti = fpti.phones;
    var ppcSyncronyProfileDeeplink, managePageLink;
    var exitView = route.exit && route.exit.view;
    switch (exitView) {
        case "add-phone":
            ppcSyncronyProfileDeeplink = commonweb_utils_1.objectUtils.safeGet(account, "phones.ppcSynchronyDeeplinks.profile");
            managePageLink = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE;
            break;
        case "validate-code-phone":
            ppcSyncronyProfileDeeplink = commonweb_utils_1.objectUtils.safeGet(account, "phones.ppcSynchronyDeeplinks.profile");
            managePageLink = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE;
            break;
        default:
            ppcSyncronyProfileDeeplink = "";
            managePageLink = "";
    }
    return (React.createElement("div", { className: "generic-container" },
        React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "updateWarning-icon", image: "Warning" }),
        React.createElement("div", { className: "updateWarning-content" },
            " ",
            React.createElement(pp_react_1.Text, { size: "xl3" }, commonContent.addUpdate.ppCreditAlert)),
        React.createElement("div", { className: "updateWarning-content" },
            " ",
            React.createElement(pp_react_1.Text, { size: "md" }, commonContent.addUpdate.ppCreditInfo)),
        React.createElement(pp_react_1.Button, { className: "continueButton fullWidth", name: phoneFpti.goToPPCredit, as: "a", href: ppcSyncronyProfileDeeplink, onClick: transitionOutHandler }, commonContent.addUpdate.ppCreditContinue),
        React.createElement(pp_react_1.Link, { "data-name": phoneFpti.notNowPPCredit, href: managePageLink }, commonContent.addUpdate.ppCreditNotNow)));
}
exports.PPCUpdate = PPCUpdate;
var mapStateToProps = function (_a) {
    var content = _a.content, account = _a.account, route = _a.route, fpti = _a.fpti;
    return ({
        content: content,
        account: account,
        route: route,
        fpti: fpti,
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(PPCUpdate);
